import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { StatusBadge } from "@/components/StatusBadge";
import { FilePlus2, FileText, Clock, CheckCircle2 } from "lucide-react";

export default function MerchantDashboard() {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/applications").then((r) => setApps(r.data)).finally(() => setLoading(false)); }, []);

  const stat = (label, value, Icon) => (
    <div className="card-flat p-5">
      <div className="flex items-center justify-between">
        <span className="text-xs uppercase tracking-[0.2em] text-slate-500">{label}</span>
        <Icon size={18} className="text-[#000091]" />
      </div>
      <div className="text-3xl font-black font-display mt-2">{value}</div>
    </div>
  );

  const done = apps.filter((a) => ["COMPLIANT", "CLOSED"].includes(a.status)).length;
  const pending = apps.filter((a) => !["COMPLIANT", "CLOSED", "REJECTED", "DRAFT"].includes(a.status)).length;

  return (
    <div className="max-w-6xl">
      <div className="flex items-end justify-between mb-8 flex-wrap gap-4">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500 mb-1">Espace commerçant</div>
          <h1 className="font-display font-black text-3xl lg:text-4xl tracking-tight">Mes dossiers d'enseigne</h1>
        </div>
        <Link to="/app/nouvelle-demande" data-testid="new-application-btn" className="bg-[#000091] text-white px-5 py-3 font-semibold hover:bg-blue-900 transition-colors flex items-center gap-2">
          <FilePlus2 size={18} /> Nouvelle demande
        </Link>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 mb-8">
        {stat("Total dossiers", apps.length, FileText)}
        {stat("En cours", pending, Clock)}
        {stat("Conformes", done, CheckCircle2)}
      </div>

      <div className="card-flat">
        <div className="px-5 py-4 border-b border-border font-semibold">Historique des demandes</div>
        {loading ? (
          <div className="p-8 text-center text-slate-500">Chargement...</div>
        ) : apps.length === 0 ? (
          <div className="p-12 text-center">
            <FileText size={40} className="mx-auto text-slate-300 mb-3" />
            <p className="text-slate-500 mb-4">Aucun dossier pour le moment.</p>
            <Link to="/app/nouvelle-demande" className="text-[#000091] font-semibold hover:underline">Créer ma première demande</Link>
          </div>
        ) : (
          <div className="divide-y divide-border">
            {apps.map((a) => (
              <Link key={a.id} to={`/app/dossier/${a.id}`} data-testid={`app-row-${a.reference}`}
                className="flex items-center justify-between px-5 py-4 hover:bg-zinc-50 transition-colors">
                <div>
                  <div className="font-semibold">{a.commercial?.business_name || a.merchant_name}</div>
                  <div className="text-sm text-slate-500 font-mono">{a.reference} · {a.sign_type} · {a.address?.city}</div>
                </div>
                <div className="flex items-center gap-4">
                  {a.precheck && <span className="text-sm font-bold font-display">{a.precheck.score}/100</span>}
                  <StatusBadge status={a.status} />
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
